@if (isCustomBoxSignupFlow()) {
<header class="bg-white top-header" [ngClass]="{'top-header--hidden-sub-nav': !isShopComponent()}"
  xmlns="http://www.w3.org/1999/html">
  <nav class="navbar navbar-expand-lg nav-main">
    <a class="navbar-brand animated fadeInDown" [class.mx-auto]="isCustomBoxSignupFlow()" href="javascript:void(0)"
      [routerLink]="['/shop']">
      <img src="assets/images/logo-main.svg?v={{logoVersionNumber()}}" alt="Mother Earth Logo" loading="lazy" />
    </a>
  </nav>
</header>
} @else {
<!--Main Navigation-->
<header class="bg-white top-header" [ngClass]="{'top-header--hidden-sub-nav': !isShopComponent()}">
  <nav class="navbar navbar-expand-lg nav-main">
    <!-- Container wrapper -->
    <!-- Toggle button -->
    @if (!isCustomBoxSignupFlow()) {
    <button class="navbar-toggler btn-header-rounded" type="button" data-bs-toggle="offcanvas"
      data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar" aria-label="Toggle navigation">
      <span class="material-symbols-outlined">menu</span>
    </button>
    }

    <!-- Left NavMenu -->
    <div class="collapse navbar-collapse">
      <ul class="navbar-nav animated fadeInDown">
        @for (page of landingPages(); track $index) {
        @if (!page.mobile) {
        <li class="nav-item" [class.has-sub-menu]="page.submenu">
          @if (page.url) {
          <a class="nav-link fw-semibold" [href]="[page.url]">{{ page.name }}</a>
          }
          @else{
          <a class="nav-link fw-semibold" [routerLink]="[page.route]">{{ page.name }}</a>
          }
          @if (page.submenu) {
          <ul class="sub-menu">
            @for (item of page.submenu; track $index) {
            @if (item.url) {
            <li><a class="nav-link" [href]="item.url">{{ item.name }}</a></li>
            } @else {
            <li><a class="nav-link" [routerLink]="[item.route]">{{ item.name }}</a></li>
            }
            }
          </ul>
          }
        </li>
        }
        }
      </ul>
    </div>

    <!-- Center logo -->
    <a class="navbar-brand animated fadeInLeft" [class.mx-auto]="isCustomBoxSignupFlow()" [routerLink]="['/shop']"
      href="#">
      <img src="assets/images/logo-main.svg?v={{logoVersionNumber()}}" alt="Mother Earth Logo" loading="lazy" />
    </a>
    <!-- Right NavMenu -->

    @if (!isCustomBoxSignupFlow()) {
    <div class="d-lg-none d-flex justify-content-center align-items-center gap-1">
      @if (isInShopComponent()) {
      <app-tags-filter class="animated fadeInRight"></app-tags-filter>
      <button class="btn-header-rounded animated fadeInRight" (click)="toggleSearchMobile()">
        <span class="material-symbols-outlined">search</span>
      </button>
      }

      <!-- @defer (on timer(0.5s)) {
      @if (isSessionLoaded() && !hasSession()) {
      <button class="btn-header-rounded px-3 animated fadeInRight" type="button" [routerLink]="['/login']">
        <strong>LOG IN</strong>
      </button>
      }
      } -->
    </div>

    <div class="offcanvas offcanvas-start d-lg-none mobile-menu" [class.top-mobile-menu]="!hasGlobalMessage()"
      [class.top-mobile-menu-global-message]="hasGlobalMessage()"
      [class.hidden-mobile-footer]="!isShowingMobileFooter()" data-bs-backdrop="true" tabindex="-1" id="offcanvasNavbar"
      aria-labelledby="offcanvasNavbarLabel">
      <div class="offcanvas-body d-flex flex-column justify-content-between">
        <ul class="navbar-nav justify-content-start flex-grow-1">
          @for (page of landingPages(); track $index) {
          <li class="nav-item">
            <a class="nav-link" [routerLink]="[page.route]" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar"
              aria-controls="offcanvasNavbar">{{ page.name }}</a>
            @if (page.submenu) {
            <ul class="sub-menu">
              @for (item of page.submenu; track $index) {
              @if (item.url) {
              <li><a class="nav-link" [href]="item.url">{{ item.name }}</a></li>
              } @else {
              <li><a class="nav-link" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar"
                  aria-controls="offcanvasNavbar" [routerLink]="[item.route]">{{ item.name }}</a></li>
              }
              }
            </ul>
            }
          </li>
          }

          @for (page of landingPagesRight(); track $index) {
          @if (!page.mobile) {
          <li class="nav-item">
            <a class="nav-link" [routerLink]="[page.route]">{{ page.name }}</a>
          </li>
          }
          }

        </ul>

        @defer (on timer(0.5s)) {
        @if (isSessionLoaded() && !hasSession()) {
        <ul class="navbar-nav justify-content-end flex-grow-1 gap-2">
          <hr>
          <li>
            <button routerLink="/login" class="btn btn-outline-primary w-100" type="button">Log In</button>
          </li>
          <li>
            <button routerLink="/signup" class="btn btn-primary w-100" type="button">
              Sign Up
            </button>
          </li>
        </ul>
        } @else {
        <ul class="navbar-nav justify-content-end flex-grow-1 mobile-menu__sub">
          <hr>
          @for (parent of settingsPages(); track $index) {
          <p class="mobile-menu__title">
            <span class="icon material-symbols-outlined">
              {{ parent.icon }}
            </span>
            <span>{{ parent.name }}</span>
          </p>
          @for (page of parent.children; track $index) {
          <li>
            <a class="nav-link" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar"
              aria-controls="offcanvasNavbar" [routerLink]="[page.route]">{{
              page.name2 &&
              !(session()?.settings?.requireAddress) ? page.name2 : page.name
              }}</a>
          </li>
          }
          }
          <hr>
          <li>
            <span class="nav-link with-action" (click)="logOut()">
              <p class="m-0">{{ userName() }}</p>
              <span class="material-symbols-outlined">login</span>
            </span>
          </li>
        </ul>
        }
        }

      </div>
    </div>

    <!-- Collapsible wrapper -->
    <div class="collapse navbar-collapse" id="navbarNav">
      <!-- right elements -->
      <ul class="navbar-nav animated fadeInDown">
        @for (page of landingPagesRight(); track $index) {
        @if (!page.mobile) {
        <li class="nav-item">
          @if (page.url) {
          <a class="nav-link fw-semibold" [href]="[page.url]">{{ page.name }}</a>
          }
          @else{
          <a class="nav-link fw-semibold" [routerLink]="[page.route]">{{ page.name }}</a>
          }
        </li>
        }
        }

        @defer (on viewport; when isSessionLoaded()) {
        @if (!signalsStoreService.hasSession()) {
        <div class="navbar-nav justify-content-end animated fadeIn">
          <button routerLink="/login" class="btn btn-outline-secondary me-2" type="button">Log In</button>
          <button routerLink="/signup" class="btn btn-secondary" type="button"> Sign Up
          </button>
        </div>
        } @else {
        <!-- Right elements -->
        <!-- <ul class="navbar-nav justify-content-end animated fadeIn"> -->
        <!-- Icon -->
        @for (element of rightElements(); track $index) {
        <li class="nav-item nav-item--icon">
          <span class="nav-link fw-semibold cursor-pointer" (click)="navigateTo(element)" [ngbTooltip]="element.tooltip"
            placement="bottom">
            <div class="position-relative">
              <span class="material-symbols-outlined" [attr.data-nav]="element.id">
                {{ element.icon }}
              </span>
              @if (element.showBadge && orderProductsQuantity()) {
              <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill quanity-badge"
                [attr.data-nav]="element.id">
                {{ orderProductsQuantity() }}
                <span class="visually-hidden">unread messages</span>
              </span>
              }
            </div>
          </span>
        </li>
        }
        <div class="vr border border-primary mx-2"></div>
        <li class="nav-item dropdown d-flex align-items-center">
          <a class="nav-link fw-semibold dropdown-toggle dropdown-toggle-split" href="#" role="button"
            data-bs-toggle="dropdown" aria-expanded="false" data-bs-reference="parent">
            {{ userName() }}
          </a>
          <ul class="dropdown-menu dropdown-menu-end">
            @for (parent of settingsPages(); track $index) {
            <h6 class="dropdown-header">
              <span class="icon material-symbols-outlined">
                {{ parent.icon }}
              </span>
              <span>{{ parent.name }}</span>
            </h6>
            @for (page of parent.children; track $index) {
            <li>
              <a class="dropdown-item" [routerLink]="[page.route]">{{
                page.name2 &&
                !(session()?.settings?.requireAddress) ? page.name2 : page.name
                }}</a>
            </li>
            }
            }
            <div class="dropdown-divider"></div>
            <li (click)="logOut()">
              <span class="nav-link with-action cursor-pointer">
                <span class="material-symbols-outlined rotate-icon">
                  login
                </span>
                <span>Log out</span>
              </span>
            </li>
          </ul>
        </li>
        <!-- </ul> -->
        }
        } @placeholder {
        <div class="placeholder-glow col-1 animated fadeIn">
          <li class="placeholder col-12 bg-secondary"></li>
        </div>
        }

      </ul>

    </div>


    
    }

  </nav>

</header>
<!--Main Navigation-->
}